import React, { memo } from 'react';

import { Card, Skeleton, Space } from 'antd';

const ShoutoutCardSkeleton: React.FC = () => {
  return (
    <div className="shoutout-card shoutout-card--skeleton">
      <Card
        className="card__content"
        style={{
          width: '100%',
          borderRadius: 12,
        }}
        bordered={false}
        bodyStyle={{ padding: 0 }}
      >
        <Space size={0} direction="vertical" style={{ width: '100%' }}>
          <Skeleton
            avatar={{ shape: 'circle', size: 40 }}
            title={{
              width: '100%',
              style: { margin: 0, marginBottom: 8, maxWidth: 200 },
            }}
            paragraph={{
              rows: 1,
              style: { margin: 0, marginBottom: 0, maxWidth: 150 },
            }}
            round
            active
            style={{
              marginBottom: 24,
            }}
          />

          <Skeleton.Button
            active
            style={{
              width: '100%',
              height: 150,
              borderRadius: 12,
            }}
            block
          />
        </Space>
      </Card>
    </div>
  );
};

export default memo(ShoutoutCardSkeleton);
